var customFaq = (() => {
  var open = (container) => {
    const sectionContainer = container.closest('.shopify-section');
    if (sectionContainer) {
      sectionContainer.querySelectorAll('[js-question-answer]').forEach(element => {
        close(element);
      });
    }
    container.classList.add('open');
    const answer = container.querySelector('[js-answer]');
    if (!answer) return;
    answer.style.maxHeight = answer.scrollHeight + 'px';
  }
  var close = (container) => {
    container.classList.remove('open');
    const answer = container.querySelector('[js-answer]');
    if (!answer) return;
    answer.style.maxHeight = '0px';
  }
  var initialize = () => {
    document.querySelectorAll('[js-question]').forEach(element => {
      element.addEventListener('click', () => {
        const container = element.closest('[js-question-answer]');
        if (container) {
          if (container.classList.contains('open')) close(container);
          else open(container);
        }
      });
    });
  }
  return {
    init: initialize
  }
})();

var app = (() => {
  var initialize = () => {
    customFaq.init();
  }
  return {
    init: initialize
  }
})();

document.addEventListener('DOMContentLoaded', () => {
  app.init();
});